import React from "react";
import { observer } from "mobx-react";
import { Button, Menu, Dropdown } from "antd";
import { DownOutlined, MessageOutlined } from "@ant-design/icons";
import { useContext } from "./context";

const MultiAction = observer(
    ({ handleUpdate, handleDelete, handleDeleteAll, handleUseChatContext }) => {
        const { context } = useContext();
        const { selected, stats, selectAll, reset } = context;
        const [dropdownOpen, setDropdownOpen] = React.useState(false);

        function close() {
            setDropdownOpen(false);
        }

        const ActionMenu = observer(({ selected, stats }) => {
            return (
                <Menu className="menu">
                    <Menu.Item
                        key="selectAll"
                        onClick={() => {
                            selectAll();
                            close();
                        }}
                        disabled={stats.selected === selected?.length}
                    >
                        Select All
                    </Menu.Item>
                    <Menu.Item
                        key="deselectAll"
                        onClick={() => {
                            reset();
                            close();
                        }}
                        disabled={stats.unSelected === selected?.length}
                    >
                        Deselect All
                    </Menu.Item>
                    {handleUpdate && (
                        <Menu.Item
                            key="update"
                            onClick={() => {
                                handleUpdate();
                                close();
                            }}
                            disabled={stats.selected === 0}
                        >
                            Update
                        </Menu.Item>
                    )}
                    {handleDelete && (
                        <Menu.Item
                            key="delete"
                            onClick={() => {
                                handleDelete(selected);
                                close();
                            }}
                            disabled={stats.selected === 0}
                            danger
                        >
                            Delete
                        </Menu.Item>
                    )}
                    {handleDeleteAll && (
                        <Menu.Item
                            key="deleteAll"
                            onClick={() => {
                                handleDeleteAll();
                                close();
                            }}
                            danger
                        >
                            Delete All
                        </Menu.Item>
                    )}
                    {handleUseChatContext && (
                        <Menu.Item
                            key="useChatContext"
                            icon={<MessageOutlined />}
                            onClick={() => {
                                close();
                                handleUseChatContext();
                            }}
                            disabled={stats.selected === 0}
                        >
                            Use selection as chat context
                        </Menu.Item>
                    )}
                </Menu>
            );
        });

        return (
            <div className="multi-action-container">
                <Dropdown
                    overlay={<ActionMenu selected={selected} stats={stats} />}
                    trigger="click"
                    placement="bottomRight"
                    visible={dropdownOpen}
                    onVisibleChange={setDropdownOpen}
                >
                    <Button>
                        Selection <DownOutlined />
                    </Button>
                </Dropdown>
            </div>
        );
    },
);

export default MultiAction;
